import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import casLogo from '../../assets/image/casLogo.png';
import { supportMail } from '../../config';

const useStyles = makeStyles(() => ({
    header: {
        borderBottom: '1px solid #dee2e6',
    },
    headerDark: {
        borderBottom: '1px solid #444',
        backgroundColor: '#292929',
        color: 'white',
    },
    body: {
        padding: '16px 20px',
    },
    bodyDark: {
        padding: '16px 20px',
        backgroundColor: '#292929',
        color: 'white',
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '10px 20px',
    },
    footerDark: {
        backgroundColor: '#292929',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '10px 20px',
    },
    agreeBtn: {
        textTransform: 'none',
        backgroundColor: '#008EC5 !important',
        color: 'white !important',
        border: '1px solid #1F4E79 !important',
    },
    agreeBtnDisabled: {
        textTransform: 'none',
    },
    agreeBtnDisabledDark: {
        textTransform: 'none',
        backgroundColor: '#3a3a3a !important',
        color: '#888 !important',
        border: '1px solid #555 !important',
    },
    declineBtn: {
        textTransform: 'none',
        marginRight: '8px',
    },
    declineBtnDark: {
        textTransform: 'none',
        marginRight: '8px',
        color: 'white !important',
        borderColor: '#888 !important',
        '&:hover': {
            borderColor: '#bbb !important',
            backgroundColor: 'rgba(255,255,255,0.08) !important',
        },
    },
    warningBox: {
        border: '1px solid #e6a817',
        backgroundColor: '#fff8ee',
        color: '#b36b00',
        borderRadius: '4px',
        padding: '10px 14px',
        margin: '10px 0',
        fontSize: '14px',
    },
    warningBoxDark: {
        border: '1px solid #e6a817',
        backgroundColor: '#3a2e1a',
        color: '#f0b040',
        borderRadius: '4px',
        padding: '10px 14px',
        margin: '10px 0',
        fontSize: '14px',
    },
    checkboxRow: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '10px',
        marginTop: '10px',
    },
    checkboxHint: {
        fontSize: '12px',
        color: '#888',
        marginTop: '4px',
        marginLeft: '26px',
    },
}));

function CASTermsModal({ show, onAccept, onDecline }) {
    const classes = useStyles();
    const toggle = useSelector(state => state.setToggle.toggle);
    const [checked, setChecked] = useState(false);

    return (
        <Modal
            show={show}
            backdrop="static"
            keyboard={false}
            size="lg"
            centered
            aria-labelledby="cas-terms-modal-title"
        >
            <Modal.Header className={toggle ? classes.header : classes.headerDark}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <img src={casLogo} alt="CAS logo" style={{ height: '40px' }} />
                    <Modal.Title id="cas-terms-modal-title">
                        General Content Use - Terms &amp; Conditions
                    </Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body className={toggle ? classes.body : classes.bodyDark}>
                <p style={{ fontSize: '14px', margin: '0 0 8px 0' }}>
                    Your GenomeQuest account has been granted access to CAS-licensed content (CAS Biosequences
                    and/or the Chemical Modification module). Before you can access this content, you must
                    review and agree to the CAS General Content Use Terms &amp; Conditions.
                </p>

                <p style={{ fontSize: '14px', margin: 0, fontWeight: 'bold' }}>
                    Please{' '}
                    <a
                        href="https://www.cas.org/legal/channel-partners"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#0009b3', fontWeight: 'bold' }}
                    >
                        click here to review the CAS data access terms of use and agreement
                    </a>
                    .
                </p>

                <div className={toggle ? classes.warningBox : classes.warningBoxDark}>
                    If you do not agree to these terms, you will be logged out of your account.<br />
                    Please contact <a href={`mailto:${supportMail}`}>{supportMail}</a> for next steps.
                </div>
                <div className={classes.checkboxRow}>
                    <input
                        type="checkbox"
                        id="casTermsCheck"
                        checked={checked}
                        onChange={e => setChecked(e.target.checked)}
                        style={{ marginTop: '3px', cursor: 'pointer', width: '16px', height: '16px', flexShrink: 0 }}
                    />
                    <label htmlFor="casTermsCheck" style={{ fontSize: '14px', cursor: 'pointer', margin: 0 }}>
                        <strong>I have read and agree to the CAS General Content Use Terms &amp; Conditions.</strong>
                    </label>
                </div>
                <div className={classes.checkboxHint}>Check the box above to enable the &ldquo;I Agree&rdquo; button.</div>
            </Modal.Body>
            <Modal.Footer className={toggle ? classes.footer : classes.footerDark}>
                <Button
                    onClick={onDecline}
                    disableRipple
                    variant="outlined"
                    className={toggle ? classes.declineBtn : classes.declineBtnDark}
                >
                    Decline and Log Out
                </Button>
                <Button
                    onClick={onAccept}
                    disableRipple
                    disabled={!checked}
                    variant="contained"
                    className={checked ? classes.agreeBtn : (toggle ? classes.agreeBtnDisabled : classes.agreeBtnDisabledDark)}
                >
                    I Agree
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CASTermsModal;
